<template>
  <div class="bg-white min-h-screen">
    <div v-if="isLoading">
      <Loader :content="true" />
    </div>
    <div v-else class="min-h-screen flex flex-col">
      <AppHeader />
      <div class="flex justify-center flex-1 py-4 items-center">
        <div class="w-[343px] sm:w-[360px]">
          <div>
            <h1
              class="font-inter font-semibold text-primary-gray-900 text-2xl sm:text-3xl sm:leading-[38px] text-center"
            >
              {{ title }}
            </h1>
            <p
              class="font-inter font-normal text-sm sm:text-base text-primary-gray-500 text-center"
            >
              {{ description }}
            </p>
            <div class="mt-7">
              <slot />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import generalMixin from '@src/mixins/general-mixins'
import { mapState } from 'vuex'
import AppHeader from '@src/router/layouts/feed/AppHeader.vue'
import Loader from '@components/BaseComponent/Loader.vue'

export default {
  components: {
    AppHeader,
    Loader,
  },
  mixins: [generalMixin],
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    headerLogo: {
      type: String,
      default: 'logoheader',
    },
  },
  data() {
    return {
      signUpPage: 'signUpPage',
    }
  },
  computed: {
    ...mapState('settings', ['siteSettingLogoURL']),
    ...mapState('layout', ['isLoading']),
  },
}
</script>
